<template>
  <section id="speakers" class="speakers" ref="speakersSection">
    <div class="container">
      <header class="section-header">
        <SectionTitle>
          {{ $t("conference.speakers.title") }}
        </SectionTitle>
        <div class="section-header__content">
          <p class="section-header__text">
            {{ $t("conference.speakers.text") }}
          </p>
          <BaseButton class="button" to="#program">
            {{ $t("conference.speakers.button") }}
          </BaseButton>
        </div>
      </header>

      <section class="speakers-list">
        <router-link
          v-for="speaker in filteredSpeakers"
          :key="speaker.id"
          class="speaker"
          :to="`${speaker.url}`"
        >
          <figure class="speaker-figure">
            <img :src="speaker.image" :alt="speaker.name" loading="lazy" />
          </figure>

          <div class="speaker-info">
            <h3 class="speaker-name">{{ speaker.name }}</h3>
            <p class="speaker-title">
              {{ speaker.title }}
              <span v-if="speaker.company">at {{ speaker.company }}</span>
            </p>
          </div>
        </router-link>
      </section>
    </div>
  </section>
</template>

<script>
import SPEAKERS from "@/data/speakers";
import SectionTitle from "@/components/common/SectionTitle.vue";
import BaseButton from "@/components/common/BaseButton.vue";

export default {
  name: "SpeakersSection",
  components: {
    SectionTitle,
    BaseButton,
  },
  data() {
    return {
      SPEAKERS,
    };
  },
  computed: {
    filteredSpeakers() {
      return this.SPEAKERS.filter((speaker) => speaker.showOnHomepage);
    },
  },
  methods: {
    handleScroll() {
      if (window.innerWidth < 1024) return;
      const section = this.$refs.speakersSection;
      const rect = section.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const offset = rect.top + scrollTop;
      const elements = section.querySelectorAll(".speaker");
      elements.forEach((el, index) => {
        const isOnlyInRow = index === elements.length - 1 && index % 3 === 0;
        const speed = index % 3 === 1 || isOnlyInRow ? -0.04 : 0.06;
        const yPos = (scrollTop - offset) * speed;
        el.style.transform = `translateY(${yPos}px)`;
        if (isOnlyInRow) {
          el.style.margin = "0 auto";
        } else {
          el.style.margin = "";
        }
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.socials {
  display: none;
}
.container {
  display: flex;
  flex-direction: column;
  /* gap: 5rem; */
  gap: clamp(2rem, 0.7228rem + 4.7525vw, 5rem);
}

.section-header {
  display: flex;
  flex-direction: column;
  /* gap: 4rem; */
  gap: clamp(1rem, -0.2772rem + 4.7525vw, 4rem);
}

.section-header__content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 522px;
  margin-left: auto;
}

.section-header__text {
  /* font-size: 1.25rem; */
  font-size: clamp(1rem, 0.8936rem + 0.396vw, 1.25rem);
  line-height: 1.5;
}

.speakers-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.speaker {
  width: calc(100% / 3);
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 20px;
  transition: transform 0.1s ease-out;
  text-decoration: none;
}
@media screen and (max-width: 768px) {
  .speaker {
    width: 100%;
    gap: 1rem;
    padding: 1rem 0;
  }
}

@media screen and (min-width: 768px) {
  .speaker:nth-child(3n + 2) {
    margin-top: 32px;
  }
}

.speaker-figure {
  width: 100%;
  height: 357px;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  background-color: var(--color-primary);
}

.speaker-figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

.speaker-info {
  display: flex;
  flex-direction: column;
  /* gap: 1rem; */
  gap: clamp(0.5rem, 0.2871rem + 0.7921vw, 1rem);
}

.speaker-name {
  /* font-size: 2rem; */
  font-size: clamp(1rem, 0.5743rem + 1.5842vw, 2rem);
  line-height: 1.125;
  font-weight: 400;
  text-transform: uppercase;
  color: var(--color-off-black);
}
.speaker-title {
  /* font-size: 1.75rem; */
  font-size: clamp(1rem, 0.6807rem + 1.1881vw, 1.75rem);
  line-height: 1.285;
  color: var(--color-primary);
}
</style>
